import React, { Component } from "react";
import { joinCss, getFileLink } from "../helpers/utils";
import LinesEllipsis from "react-lines-ellipsis";

import appClasses from "../App.module.scss";

class openFileLink extends Component {
  render() {
    const classes = this.props.componentContant
      ? this.props.localClass
      : joinCss(this.props.localClass, appClasses.pdfLink);
    const contant = this.props.componentContant ? (
      this.props.linkContant
    ) : (
      <LinesEllipsis
        className={joinCss(appClasses.pdfName, this.props.textLocalClass)}
        maxLine={this.props.numOfLines}
        text={this.props.contant}
      />
    );
    return (
      <a
        className={classes}
        href={getFileLink(this.props.id, this.props.contant)}
        onClick={e => e.stopPropagation()}
        target="_blank"
      >
        {contant}
      </a>
    );
  }
}
export default openFileLink;
